import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {PinLockComponent} from './pin-lock.component';
import {IonicModule} from '@ionic/angular';

@NgModule({
    declarations: [
        PinLockComponent
    ],
    imports: [
        CommonModule,
        IonicModule
    ],
    exports: [
        PinLockComponent
    ]
})
export class PinLockModule { }
